module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-section"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d75bc7f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/controls/GroupControl.vue
// module id = 2513
// module chunks = 1